import useWindowSize from "../../customHooks/useWindowSize";
import ImageImports from '../../utils/ImageImports';
import Button from "../Button/Button";

const { Arrow } = ImageImports;

interface PaginationProps {
    resultsPerPage: number;
    resultCount: number;
    pageNumbers: number[];
    pageCount:number;
    currentPage: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    totalRecords: number;
    setResultsPerPage: (n: number) => void;
    previousPage: () => void;
    nextPage: () => void;
    setCurrentPage: (n: number) => void;
}

export const Pagination = ({
    resultsPerPage,
    resultCount,
    pageNumbers,
    currentPage,
    hasPreviousPage,
    hasNextPage,
    setResultsPerPage,
    pageCount,
    previousPage,
    nextPage,
    setCurrentPage,
    totalRecords,
}: PaginationProps) => {
    const { isMobile, isTablet } = useWindowSize();
    return (
        <div className={`flex flex-col md:flex-row items-center justify-center md:justify-between w-full text-sm`}>
            <div className={`flex flex-col md:flex-row gap-4`}>
                <span className={`align-center flex justify-center md:justify-around`}>
                    {Math.min(resultsPerPage, resultCount)} of {totalRecords} Result{totalRecords !== 1 && "s"}
                </span>
                {pageCount > 1 && totalRecords > 0 && totalRecords > 16 && resultsPerPage !== totalRecords && 
                    <Button
                        className="whiteBtn show_all !mb-0"
                        text={isMobile || isTablet ? "Show All Results": "Show All"}
                        onClick={() => setResultsPerPage(totalRecords)}
                        style={{ order: isMobile ? "-1" : "unset" }}
                    />
                }
            </div>
           { pageCount > 1 && <div className={`flex flex-row flex-nowrap justify-center items-start mt-5 md:mt-0`}>
                <img
                src={Arrow}
                className={`pagination-left-arrow flex flex-col justify-center h-9 w-9 `}
                alt="arrow"
                style={hasPreviousPage ? {filter: "invert(31%) sepia(21%) saturate(786%) hue-rotate(150deg) brightness(94%) contrast(83%)"} : {}}
                onClick={() => {
                        if (hasPreviousPage) {
                            previousPage();
                        }
                    }}
                />
                {pageNumbers.map((pageNumber) => (
                    <span
                        key={pageNumber}
                        className={` p-3 text-dark-blue relative cursor-pointer`}
                        onClick={() => {
                            setCurrentPage(pageNumber);
                        }}
                    >
                        <span className={`absolute top-[6px] left-[2px] h-6 w-6 rounded flex items-center justify-center ${pageNumber === currentPage ? 'font-bold bg-primary-20' : ""}`}>
                            {pageNumber}
                        </span>
                    </span>
                ))}
                <img
                    src={Arrow}
                    className="pagination-right-arrow flex flex-col justify-center padding-3 h-9 w-9"
                    alt="arrow"
                    style={hasNextPage ? {filter: "invert(31%) sepia(21%) saturate(786%) hue-rotate(150deg) brightness(94%) contrast(83%)"} : {}}
                    onClick={() => {
                        if (hasNextPage) {
                            nextPage();
                        }
                    }}
                />
            </div>}
        </div>
    );
}